import { useQuery } from "react-query";
import servicesUtils from "../../../../utils/servicesUtils";

const useGetConversationMessages = (workspaceId, conversationId, isEnabled) => {
  let url = `/llm_orchestrator/workspaces/${workspaceId}/conversations/${conversationId}/messages/`;

  return useQuery(
    ["conversations", workspaceId, conversationId],
    () => servicesUtils.getService(url),
    {
      enabled: isEnabled,
      staleTime: 0,
    }
  );
};

export default useGetConversationMessages;
